import React from 'react';

const NotFound = () => {
    return (
        <div className='flex justify-center items-center mt-28'>
            <img src={`https://img.freepik.com/free-vector/error-404-concept-landing-page_52683-19458.jpg?size=626&ext=jpg&ga=GA1.1.797603842.1642089981`} alt="" />
        </div>
    );
};

export default NotFound;